export type IFlyerDetailsResources = typeof FlyerDetailsResources;

export const FlyerDetailsResources = {
    allOffersBrand: "PROMOCJE {0}",
};
